import { render, staticRenderFns } from "./PermissaoUpdate.vue?vue&type=template&id=4a1b8394&scoped=true&"
import script from "./PermissaoUpdate.vue?vue&type=script&lang=js&"
export * from "./PermissaoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b8394",
  null
  
)

export default component.exports